import { TFunction } from 'i18next';

import { FooterDataType } from './types.ts';

export const getFooterData = (brand: string, t: TFunction): FooterDataType => {
	switch (brand) {
		case 'pm':
			return {
				apps: [
					{
						icon: 'android',
						link: 'https://parimatch.onelink.me/hyhP/v2fqt0je'
					},
					{
						icon: 'gallery',
						link: 'https://parimatch.onelink.me/hyhP/v2fqt0je'
					},
					{
						icon: 'galaxy',
						link: 'https://parimatch.onelink.me/hyhP/v2fqt0je'
					},
					{
						icon: 'ios',
						link: 'https://parimatch.onelink.me/hyhP/v2fqt0je'
					}
				],
				social: [],
				description: t('license')
			};
		case 'com2':
			return {
				apps: [
					{
						icon: 'android',
						link: 'https://viphouse.onelink.me/at9F/androidapp'
					},
					{
						icon: 'ios',
						link: 'https://viphouse.onelink.me/at9F/iosapp'
					}
				],
				social: []
			};
		case 'ngu3':
			return {
				apps: [
					{
						icon: 'android',
						link: 'https://johnny24.onelink.me/7JeJ/download'
					}
				],
				social: [
					{ icon: 'tg', link: 'https://t.me/johnny24_bet/' },
					{ icon: 'instagram', link: 'https://www.instagram.com/johnny24_bet/' }
				]
			};
		default:
			return {} as FooterDataType;
	}
};
